import React, { Fragment } from 'react';
import { object, string } from 'prop-types';
import styled from 'styled-components';

import { Experiment, Variant } from '@olxbr/react-experimentation';

import ChatSalesForce from './core/components/ChatSalesForce';
import StepRenderer from './core/components/StepRendererContainer';
import Footer from './core/components/footer';
import ConfirmationModal from './core/components/ConfirmationModalContainer';
import OlxProPopup from './subscription/components/OlxProPopupContainer';
import './subscription/General.css';
import SwitchStep from './core/components/SwitchStepContainer';
import Header from './core/components/header/Header';
import Navbar from './core/components/navbar/NavbarContainer';
import LandingNavbar from './landing/components/NavbarContainer';
import { isNotWebview } from './core/libs/browser/browser';
import AboutLimitsnModal from './core/components/AboutLimitsModalContainer';

const Wrapper = styled.header`
  width: 100%;
  display: block;
  margin: 0 auto;
  @media(min-width:1000px) {
    width: 970px;
  }
`;

const marketPlaceCategories = [
  2101, 2103, 2105, 2102, 2104,
  3020, 3040, 3060, 3080,
  5020, 5040, 5060, 5080, 5100,
  6020, 6060,
  7080,
  8020, 8040, 8060, 8080,
  9020,
  10040, 10060, 10080, 10100, 10120, 10140,
  11020, 11040, 11060, 11080, 11100,
  12040, 12060, 12080, 12100, 12160,
];

const getRetargetingIframe = adUUID => (
  <iframe src={`//us.creativecdn.com/tags?id=pr_Zt7ywGZEZYDBQfc1VyIo_orderstatus2_1_${adUUID}_advert&cd=default`} title="RTB Tag" width="1" height="1" scrolling="no" frameBorder="0" style={{ display: 'none' }} />
);

const RTBTags = ({ tagId, productName }) => (
  <Fragment>
    <iframe src={`//us.creativecdn.com/tags?id=${tagId}_offer_${productName}&id=${tagId}_custom_plan_${productName}`} title="RTB Tag" width="1" height="1" scrolling="no" frameBorder="0" style={{ display: 'none' }} />
  </Fragment>
);

RTBTags.propTypes = {
  tagId: string.isRequired,
  productName: string.isRequired,
};

const PointOfSale = ({ posData, extrasData, adData }) => {
  const { parentName, currentStep, standAlone } = posData;

  window.hotjarTrigger(parentName, adData.categoryId);

  return (
    <Fragment>
      {(currentStep === 'subscription' ||
        (currentStep === 'highlights' && parentName !== 'free-insertion' && parentName !== 'free-edition' && parentName !== 'fee-renewal' && parentName !== 'free-renewal' && parentName !== 'fee-insertion') ||
        currentStep === 'highlights-subscription') &&
        <Fragment>
          {currentStep === 'subscription' && standAlone ? <LandingNavbar right /> : <Navbar />}
          <Wrapper>
            <Header />
          </Wrapper>
          {!standAlone && (currentStep === 'subscription' || currentStep === 'highlights-subscription') && <SwitchStep />}
        </Fragment>}
      {((currentStep === 'subscription' || currentStep === 'vertical' || currentStep === 'marketing') &&
        <Experiment name="osp-chat-salesforce">
          <Variant value="show">
            <ChatSalesForce />
          </Variant>
        </Experiment>
      )}
      <StepRenderer />
      {isNotWebview && <Footer marginTop={parentName !== 'free-insertion' || parentName !== 'free-edition'} />}
      <ConfirmationModal />
      <AboutLimitsnModal funnelId={posData.funnelId} pointOfSale={posData.name} />
      <OlxProPopup />
      {extrasData.rtb && <RTBTags tagId={extrasData.rtb.tag_id} productName={extrasData.rtb.product_name} />}
      {marketPlaceCategories.find(element => element === adData.categoryId) && parentName === 'free-insertion' && getRetargetingIframe(adData.adId)}
    </Fragment>
  );
};

PointOfSale.propTypes = {
  posData: object.isRequired,
  extrasData: object.isRequired,
  adData: object.isRequired,
};

export default PointOfSale;
